import React, { useMemo } from "react";
import useSeo from "../seo/useSeo";
import useJsonLd from "../seo/useJsonLd";
import PdfToImages from "../components/PdfToImages";

export default function PdfToJpgPage() {
  useSeo({
    title: "PDF en JPG – Convertir un PDF en images JPG | pdf-convert.fr",
    description:
      "Convertissez un PDF en images JPG en ligne. Rapide, gratuit, traitement local (aucun fichier envoyé).",
    canonical: "https://pdf-convert.fr/pdf-jpg",
  });

  const breadcrumbJsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Accueil",
          item: "https://pdf-convert.fr/home",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Conversion",
          item: "https://pdf-convert.fr/conversion",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "PDF en JPG",
          item: "https://pdf-convert.fr/pdf-jpg",
        },
      ],
    }),
    []
  );

  useJsonLd("breadcrumb-pdf-jpg", breadcrumbJsonLd);

  const faqItems = useMemo(
    () => [
      {
        q: "Comment convertir un PDF en JPG ?",
        a: "Importez votre PDF puis lancez la conversion. Chaque page sera exportée en image JPG téléchargeable.",
      },
      {
        q: "Mes fichiers sont-ils envoyés sur un serveur ?",
        a: "Non. La conversion se fait directement dans votre navigateur. Aucun fichier n’est envoyé ni stocké.",
      },
      {
        q: "Pourquoi choisir JPG plutôt que PNG ?",
        a: "Le JPG est souvent plus léger pour partager ou envoyer des images. Le PNG conserve mieux certains détails mais peut être plus lourd.",
      },
    ],
    []
  );

  const faqJsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqItems.map((it) => ({
        "@type": "Question",
        name: it.q,
        acceptedAnswer: { "@type": "Answer", text: it.a },
      })),
    }),
    [faqItems]
  );

  useJsonLd("faq-jsonld-pdf-jpg", faqJsonLd);

  return (
    <main style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
      <h1>PDF → JPG</h1>
      <p style={{ textAlign: "center", color: "#666" }}>
        Conversion rapide en JPG (souvent plus léger). Aucun envoi, tout se fait
        dans votre navigateur.
      </p>

      <PdfToImages defaultFormat="jpg" />
    </main>
  );
}
